import { takeLatest, put, call, all, fork } from "redux-saga/effects";
import { CaseService } from "services";

import { fetchedCasesCount, failedFetchCasesCount } from "actions";
import { CASE_ACTIONS } from "constants";

function* caseCountFetchHandler() {
    try {
        const [
            { data: inboxCount, error: inboxError },
            { data: participatedCount, error: participatedError }
        ] = yield all([
            call(CaseService.getCasesCount, "inbox"),
            call(CaseService.getCasesCount, "participated")
        ]);
        if (!(inboxError && participatedError)) {
            yield put(
                fetchedCasesCount({
                    INBOX: inboxCount,
                    PARTICIPATED: participatedCount
                })
            );
        } else {
            yield put(failedFetchCasesCount(inboxError || participatedError));
        }
    } catch (error) {
        console.error(error);
    }
}

export default fork(function*() {
    yield takeLatest(CASE_ACTIONS.FETCH_CASES_COUNT, caseCountFetchHandler);
});
